import React from 'react';
import UpdateCommande from '../../components/organisms/forms/UpdateCommande';
import {
  Enum_Commande_Methodepaiement,
  Enum_Commande_Status
} from '../../graphql/generated/graphql';
import DejaPaye from './DejaPaye';
import AFinaliser from './AFinaliser';
import Annule from './Annule';
import { CommandeDef } from '../../types/commande/commande.def';
import OutForDelivery from './OutForDelivery';

interface CommandeUpdateViewProps {
  commande: CommandeDef;
}

const CommandeUpdateView = ({ commande }: CommandeUpdateViewProps) => {
  if (commande.controlled)
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          width: '70%',
          maxHeight: '500px',
          margin: 'auto',
          padding: '200px 0'
        }}
      >
        <h2>
          Cette commande est contrôlée{' '}
          <span role="img" aria-label="emojis_déçu">
            😕
          </span>
        </h2>
        <p>
          Il est impossible de modifier cette commande que vous avez déjà
          contrôlée. Pour la modifier veuillez changer le statut de contrôle.
          (Ma classe
          <span role="img" aria-label="emojis_main vers la droite">
            👉🏼
          </span>
          Contrôle des commandes)
        </p>
      </div>
    );
  if (
    commande.status === Enum_Commande_Status.Paye &&
    commande.methodepaiement === Enum_Commande_Methodepaiement.Cb
  )
    return <DejaPaye commande={commande} />;
  if (commande.status === Enum_Commande_Status.Annule)
    return <Annule commande={commande} />;
  if (commande?.livraison?.status)
    return <OutForDelivery commande={commande} />;

  if (
    commande.status === Enum_Commande_Status.AFinaliser ||
    commande.status === Enum_Commande_Status.NonPaye
  )
    return <AFinaliser commande={commande} />;
  return <UpdateCommande commande={commande} />;
};
export default CommandeUpdateView;
